import { PrivateRoute, PublicRoute, AdminRoute } from '../utils/RouteUtils';
import { Route, Routes, useLocation } from 'react-router-dom';

import RecentEvents from '../pages/RecentEvents';
import Login from '../pages/Login';
import DashboardTopNavbar from '../pages/TopNavbar';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import AddUser from '../pages/AddUser';
import Statisticsv2 from '../pages/Statisticsv2';
import Dashboard from '../pages/Dashboard';
import TurbineInteraction from '../pages/TurbineInteraction';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

export default function Router() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [location]);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardTopNavbar />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route
          path="recent-events"
          element={
            <PrivateRoute>
              <RecentEvents />
            </PrivateRoute>
          }
        />
        <Route
          path="statistics"
          element={
            <PrivateRoute>
              <Statisticsv2 />
            </PrivateRoute>
          }
        />
        <Route
          path="turbine-interaction"
          element={
            <PrivateRoute>
              <TurbineInteraction />
            </PrivateRoute>
          }
        />
        <Route
          path="add-user"
          element={
            <AdminRoute>
              <AddUser />
            </AdminRoute>
          }
        />
      </Route>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password/token=:token"
        element={
          <PublicRoute>
            <ResetPassword
              headerText={'Reset Your Password'}
              buttonText={'Reset Password'}
              successMessage={'Password is reset successfully'}
            />
          </PublicRoute>
        }
      />
      <Route
        path="/create-password/token=:token"
        element={
          <PublicRoute>
            <ResetPassword
              headerText={'Enter New Password'}
              buttonText={'Save Password'}
              successMessage={'Password is set successfully'}
            />
          </PublicRoute>
        }
      />
    </Routes>
  );
}
